<script>

import VJsoneditor from 'v-jsoneditor'
import DocumentMixin from '@/mixins/DocumentMixin'
import CorpusMixin from '@/mixins/CorpusMixin'
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'CorpusSources',
  mixins: [DocumentMixin, CorpusMixin],
  components: { VJsoneditor },
  data() {
    return {
      docName: '',
      inputLink: {
        loading: false,
        start: {
          url: ''
        },
        end: {
          url: ''
        }
      },

      linkShow: true,
      parsedDoc: {
        loading: false,
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['HAS_PERMISSION']),
    stateInputLinkEnd() {
      if (this.inputLink.end.docId && this.inputLink.start.docId) {
        return this.inputLink.end.docId === this.inputLink.start.docId
      }
      return true
    },
    stateInputLinkStart() {
      return !!(this.inputLink.start.url && this.inputLink.start.docId && this.inputLink.start.anchor)
    }
  },
  mounted() {
    this.loadCorpusById(true)
    // _FIXME rm
    // this.inputLink.start.url = 'https://library.mededtech.ru/rest/documents/ISBN9785970475379/?anchor=Глава_22_Заболевания_легочной_артерии#Глава_22_Заболевания_легочной_артерии'
    // this.inputLink.end.url = 'https://library.mededtech.ru/rest/documents/ISBN9785970475379/#paragraph_3fnuhk'
  },
  watch: {
    corpusId() {
      this.loadCorpusById(true)
    },
    'inputLink.start.url'(url) {
      this.inputLink.start = this.parseLink(url)
    },
    'inputLink.end.url'(url) {
      this.inputLink.end = this.parseLink(url)
    }
  },
  methods: {
    callHandleDoc(noAutoList) {
      this.inputLink.loading = true
      this.loadDocumentData(this.inputLink.start.docId, this.inputLink.start.anchor).then(docData => {
        this.docName = docData.docName
        this.callParseDoc(noAutoList)
      })
          .catch((err) => {
            throw err
          })
          .finally(() => this.inputLink.loading = false)
    },
    callParseDoc(noAutoList) {
      this.parsedDoc.loading = true
      api.post(`/doc/${ this.inputLink.start.docId }/parse`, {
        anchors: {
          start: this.inputLink.start.anchor,
          end: this.inputLink.end.anchor
        }
      }, {
        params: {
          'no-auto-list': noAutoList
        }
      })
          .then(
              (response) => {
                // console.log(response)
                this.parsedDoc.data = response.data
                if (response.data.length === 0) {
                  this.$bvToast.toast(
                      'Парсинг вернул пустой результат. Проверьте ссылки', {
                        ...this.commonToaster, variant: 'warning'
                      }
                  )
                }
              }
          )
          .catch(({ response }) => {
            if (response.status === 404) {
              // если документа нет, он ошибка в другом месте кидается
            }
          })
          .finally(() => this.parsedDoc.loading = false)
    },

    checkDocInSources() {
      return this.corpus?.data?.sources?.map(x => x.document_id).includes(this.inputLink.start.docId)
    },
    callAppendSource() {
      this.corpus.loading = true
      api.post(`/corpus/${ this.corpus.data.id }/source`, {
        docId: this.inputLink.start.docId,
        sections: this.parsedDoc.data
      })
          .then((response) => {
            this.corpus.data = response.data
            this.$bvToast.toast('Добавлен новый источник', {
              ...this.commonToaster, variant: 'success'
            })
          })
          .catch(({ response }) => {
            if (response.status === 404) {
              // если документа нет, он ошибка в другом месте кидается
              this.$bvToast.toast(
                  'Корпус не найден', {
                    ...this.commonToaster, variant: 'danger'
                  }
              )
              return
            }
            this.$bvToast.toast(
                'Неизвестная ошибка при добавлении источника в корпус', {
                  ...this.commonToaster, variant: 'danger'
                }
            )
            console.log(response)
          })
          .finally(() => this.corpus.loading = false)
    },
    callDeleteSource(source) {
      this.$bvModal.msgBoxConfirm(`Удалить источник "${ source.title }" из корпуса текстов "${ this.corpus.data.name }"?`, {
        okVariant: 'danger',
        okTitle: 'Да',
        cancelTitle: 'Нет',
        hideHeaderClose: false,
        centered: true
      }).then((confirm) => {
        if (!confirm) return
        this.corpus.loading = true
        api.delete(`/corpus/source/${ source.id }`).then(() => {
          const index = this.corpus.data.sources.indexOf(source)
          this.corpus.data.sources.splice(index, 1)
        })
            .then(() => {
              this.$bvToast.toast('Источник удален', {
                ...this.commonToaster, variant: 'success'
              })
            })
            .catch((error) => {
              if (error.response.status === 404) {
                // если документа нет, он ошибка в другом месте кидается
                this.$bvToast.toast(
                    'Источник не найден', {
                      ...this.commonToaster, variant: 'danger'
                    }
                )
                return
              }
              this.$bvToast.toast(
                  'Неизвестная ошибка при удалении источника из корпуса', {
                    ...this.commonToaster, variant: 'danger'
                  }
              )
              console.log(error)
            })
            .finally(() => this.corpus.loading = false)
      })
    }
  }
}
</script>

<template>
  <b-container class="p-2" fluid>
    <b-row no-gutters>
      <b-col class="pr-2" cols="12" md="6">
        <!--Список источников-->

        <b-card v-if="corpus.data.sources" title="Список источников">
          <b-skeleton-wrapper :loading="corpus.loading">
            <template #loading>
              <b-skeleton-img height="70vh" no-aspect/>
            </template>
            <b-card-text style="height: 70vh; overflow-y: scroll;">
              <b-list-group>
                <b-list-group-item
                    v-for="(source, sourceNumber) in corpus.data.sources"
                    :key="`source-${sourceNumber}}`"
                    :variant="source.document_id === inputLink.start.docId ? 'warning' : ''"
                    class="d-flex justify-content-between align-items-center"
                >
                  <div class="flex-grow-1">
                    {{ sourceNumber + 1 }}. {{ source.title }}
                  </div>
                  <b-badge pill variant="dark">
                    <span v-b-tooltip.hover title="Количество разделов">
                      {{ source.sections.length }} §
                    </span>
                  </b-badge>
                  <b-button-close v-if="HAS_PERMISSION('corpus_source_edit')" @click="callDeleteSource(source)"/>

                </b-list-group-item>
              </b-list-group>
            </b-card-text>
          </b-skeleton-wrapper>

        </b-card>
      </b-col>
      <b-col v-if="corpus.data.sources" cols="12" md="6">
        <b-card
            v-if="HAS_PERMISSION('corpus_source_edit')"
            sub-title="Укажите ссылки на начало и конец парсинга в документе"
            title="Добавить документ в корпус"
        >
          <b-button v-if="docName" v-b-toggle.accordion-1 block variant="secondary">
            {{ docName }}
          </b-button>
          <b-input-group class="my-2" prepend="Начало">
            <b-input v-model="inputLink.start.url" :state="stateInputLinkStart"
                     placeholder="Первый раздел, который парсится"/>
            <b-input-group-append>
              <b-btn :disabled="!stateInputLinkStart" :href="inputLink.start.url" target="_blank"
                     variant="outline-primary">
                <font-awesome-icon icon="link"/>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group class="my-2" prepend="Конец">
            <b-input v-model="inputLink.end.url" :state="stateInputLinkEnd"
                     placeholder="Последний параграф который парсится"/>
            <b-input-group-append>
              <b-btn :disabled="!(stateInputLinkEnd && inputLink.end.url)" :href="inputLink.end.url"
                     target="_blank"
                     variant="outline-primary">
                <font-awesome-icon icon="link"/>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <b-button-group v-if="stateInputLinkStart && stateInputLinkEnd">
            <b-btn
                :disabled="inputLink.loading"
                variant="primary"
                @click="callHandleDoc()"
            >
              <font-awesome-icon icon="share-from-square"/>
              Обработка
            </b-btn>
            <b-btn
                :disabled="inputLink.loading"
                variant="warning"
                @click="callHandleDoc(true)"
            >
              <font-awesome-icon icon="share-from-square"/>
              Без обработки списков
            </b-btn>
            <b-btn
                v-if="parsedDoc.data.length"
                :disabled="inputLink.loading || checkDocInSources()"
                variant="success"
                @click="callAppendSource"
            >
              Вставить новый источник
            </b-btn>
          </b-button-group>
          <b-alert :show="checkDocInSources()" variant="danger">
            Этот документ уже находится в источниках
          </b-alert>
        </b-card>

        <div class="mt-2">
          <b-card v-if="parsedDoc.data.length || parsedDoc.loading" title="Обработанный документ">
            <b-skeleton-wrapper :loading="parsedDoc.loading">
              <template #loading>
                <b-skeleton-img height="40vh" no-aspect/>
              </template>
              <b-input-group>
                <v-jsoneditor
                    v-model="parsedDoc.data"
                    :options="{
                      mainMenuBar: true,
                      statusBar: true,
                      mode: 'code',
                      language: 'ru',
                      enableSort: false
                    }"
                    height="40vh"/>

              </b-input-group>
            </b-skeleton-wrapper>
          </b-card>
        </div>

      </b-col>
    </b-row>
  </b-container>
</template>

<style>

</style>